import { useHandler } from "@redotech/react-util/hook";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OnboardingProps } from "../common";

const HUBSPOT_LINK =
  "https://meetings.hubspot.com/bernhunter/cross-border-beta";

export const CrossBorderOnboardingModal = memo(
  function CrossBorderOnboardingModal({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const handleBookDemo = useHandler(() => {
      window.open(HUBSPOT_LINK, "_blank");
      handleComplete();
    });

    const handleClose = useHandler(() => {
      handleDismiss();
    });

    return (
      <RedoModal
        hideCloseButton
        isOpen
        modalSize="sm"
        onModalCloseRequested={handleClose}
        primaryButton={{
          text: "Book time to join the beta",
          onClick: handleBookDemo,
          size: "sm",
        }}
        secondaryButton={{ text: "Dismiss", onClick: handleClose, size: "sm" }}
        subtitle="Stop losing international sales to surprise duties and taxes."
        title="Tariff troubles?"
      >
        <Text fontSize="sm">
          <strong>Redo's cross-border shipping</strong> beta shows shoppers the
          guaranteed total cost at checkout.
        </Text>
      </RedoModal>
    );
  },
);
